(function() {
  'use strict';

  angular.module('ringbaPortal').component('userTasksList', {
    bindings: {
      taskStatus: '@',
      loadingText: '@',
      emptyTasksText: '@',
      reloadData: '<',
      highlightTaskId: '<',
      isOfferTasks: '<', // Flag to show offer related tasks
      campaignId: '<', // Useful for offer related tasks
      setTasksCountOnTabHeader: '&',
      resetHighlightedTask: '&',
      reloadDataForStatus: '&', // This is used to reload data for other status' list, when an action is done on a task
      showTab: '&'
    },
    controller: UserTasksListController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/user-tasks/user-tasks-list/user-tasks-list.view.html'
  });

  function UserTasksListController(
    $interval,
    $timeout,
    accountsService,
    userTasksService
  ) {
    'ngInject';

    const vm = this;

    const removeItemTimeoutsByItemIndex = {};
    const removeItemAfterTime = 15;
    let pendingOfferTasksInterval;

    vm.currentPage = 1;
    vm.itemsPerPage = 10;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;
    vm.showTaskDetails = showTaskDetails;
    vm.hideTaskDetails = hideTaskDetails;
    vm.setTaskDetails = setTaskDetails;
    vm.gotoTab = gotoTab;
    vm.showCompletedRequest = showCompletedRequest;

    function onInit() {
      vm.loading = true;
      _loadTasks();
      vm.sortByTime = vm.taskStatus === 'completed' ? 'completionTime' : 'creationTime';
    }

    function onChanges(changesObj) {
      if (changesObj.reloadData && vm.reloadData) {
        _loadData();
      }

      if (changesObj.highlightTaskId && vm.highlightTaskId) {
        _openTaskDetails(vm.highlightTaskId);
      }

      if (changesObj.campaignId && vm.isOfferTasks && vm.campaignId) {
        _loadData();
      }
    }

    function onDestroy() {
      _cancelInterval();
    }

    function showTaskDetails(task) {
      if (task) {
        _cancelInterval();
        task.showTaskDetails = true;

        if (vm.highlightTaskId) {
          vm.resetHighlightedTask();
        }
      }
    }

    function hideTaskDetails(task) {
      task.showTaskDetails = false;
      _setIntervalForPendingOfferTasks();
    }

    // Use this after editing a task
    // Used to change the task details in the tasks list itself instead of loading the list of tasks again
    function setTaskDetails($index, details) {
      details.showTaskDetails = true;

      if(details.status !== vm.taskStatus) {
        vm.reloadDataForStatus({
          status: details.status
        });
        _removeListItemAfterTime(removeItemAfterTime, vm.tasks[$index].id);
        vm.setTasksCountOnTabHeader({
          count: vm.tasks.length - Object.keys(removeItemTimeoutsByItemIndex).length,
          taskStatus: vm.taskStatus
        });
      }
      vm.tasks[$index] = details;
    }

    function gotoTab(task, $index) {
      const finalIndex = ((vm.currentPage - 1) * vm.itemsPerPage) + $index,
        taskId = vm.tasks[finalIndex].id;
      $timeout.cancel(removeItemTimeoutsByItemIndex[taskId]);
      _removeTaskItem(taskId);
      vm.showTab({ status: task.status, taskId: taskId });
    }

    function showCompletedRequest(task) {
      vm.showTab({ status: task.status });
    }

    function _openTaskDetails(taskId) {
      $timeout(function() {
        const task = _.find(vm.tasks, { id: taskId  });
        if (task) {
          _setCurrentPageForTask(taskId);
          showTaskDetails(task);
        }
      }, 200);
    }

    function _setCurrentPageForTask(taskId) {
      const sortByTime = vm.taskStatus === 'completed' ? 'completionTime' : 'creationTime';
      const sortedTasks = _.orderBy(vm.tasks, function(task) {
        return -new Date(task[sortByTime]).getTime();
      });
      const taskIndex = _.findIndex(sortedTasks, { id: taskId });
      vm.currentPage = Math.ceil((taskIndex + 1)/vm.itemsPerPage);
    }

    function _removeListItemAfterTime(timeInSeconds, taskId) {
      removeItemTimeoutsByItemIndex[taskId] = $timeout(function() {
        _removeTaskItem(taskId);
      }, timeInSeconds * 1000);
    }

    function _removeTaskItem(taskId) {
      _.remove(vm.tasks, { id: taskId });
      delete removeItemTimeoutsByItemIndex[taskId];
    }

    function _loadData() {
      vm.loading = true;

      if (vm.isOfferTasks && !vm.campaignId) {
        return;
      }

      _loadTasks().then(function() {
        vm.currentPage = 1;
      });
    }

    // TODO: Move this in the parent component
    function _loadTasks() {
      if (vm.isOfferTasks && vm.campaignId) {
        return _getOfferTasks().then(_setIntervalForPendingOfferTasks);
      } else if (!vm.isOfferTasks) {
        return _getAllTasks();
      }
    }

    function _getOfferTasks() {
      return userTasksService.getOfferParticipationTasks(accountsService.currentAccountId, vm.campaignId, vm.taskStatus).then(_tasksResponseHandler);
    }

    function _getAllTasks() {
      return userTasksService.getTasks(accountsService.currentAccountId, vm.taskStatus).then(_tasksResponseHandler);
    }

    function _setIntervalForPendingOfferTasks() {
      if (vm.isOfferTasks && vm.taskStatus === 'open' && !pendingOfferTasksInterval) {
        pendingOfferTasksInterval = $interval(_getOfferTasks, 15000);
      }
    }

    function _tasksResponseHandler(response) {
      vm.tasks = response.data.jobs;
      vm.loading = false;
      vm.setTasksCountOnTabHeader({
        count: (vm.tasks && vm.tasks.length) || 0,
        taskStatus: vm.taskStatus
      });
      if(vm.highlightTaskId) {
        _openTaskDetails(vm.highlightTaskId);
      }
    }

    function _cancelInterval() {
      if (pendingOfferTasksInterval) {
        $interval.cancel(pendingOfferTasksInterval);
        pendingOfferTasksInterval = null;
      }
    }


  }
})();
